import { Banner } from "widgets/fallbacks/Banner";

export function Reviews() {
  return (
    <Banner title={'Данный раздел сайта находится в разработке'} />
  )
}